export function FieldError({ children }: { children?: string }) {
  return children ? (
    <p className="text-sm text-red-700" role="alert">
      {children}
    </p>
  ) : null;
}
